<div class="markDownSec" style="margin-top: -60px;">
    <ng-container *ngIf="isFile; else showWithData">
        <markdown [src]="fileSrc" class="markDownContent"></markdown>
    </ng-container>
    <ng-template #showWithData>
        <markdown [data]="textContent" class="markDownContent"></markdown>
    </ng-template>
</div>